import { useContext, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { AppContext } from "../context/context"
import { live } from "../config/delcare"
import UiSpinner from "../components/ui_spinner"

const SidebarDashboardBrand = ({ path }) => {



	const { neonUser, brand, } = useContext(AppContext)
	const [storageParam, setStorageParam] = useState("")
	useEffect(() => {
		try {
			// setStorageParam(JSON.stringify(window.localStorage))
			// console.log(JSON.stringify(window.localStorage))
			const auth0Pattern = /^@@auth0spajs@@/
			const filtered = {}
			Object.keys(window.localStorage).forEach(key => {
				if (auth0Pattern.test(key)) {
					filtered[key] = window.localStorage.getItem(key)
				}
			})
			setStorageParam(JSON.stringify(filtered))
		}
		catch (err) {
			console.log("ERROR IN GOING TO SIDEKICK APP WITH LOCALSTORAGE PARAM")
		}
	}, [])



	if (!neonUser.user || !neonUser.user.role) return (
		<div className="d-flex justify-content-center">
			<UiSpinner color="white" />
		</div>
	)



	// if (!brand?.brand_entity_id) return (
	// 	<div className="poppins">
	// 		No brand found
	// 	</div>
	// )
	return (
		<>

			<Link to="/" style={{ textDecoration: "none" }}>
				<div className="d-flex gap-2">
					{path == "/" ?
						<div style={{ width: 35, height: 35 }} className="bg-white p-1 rounded opacity-75">
							<img src={"/src/activity.svg"} className="w-100 opacity-100" />
						</div>
						:
						<div className=" p-1 rounded off-icon">
							<img src={"/src/activity-off.svg"} className="w-100" />
						</div>
					}
					<p className="text-white fs-6 m-0 align-self-center">Status</p>
				</div>
			</Link>




			{neonUser && ["owner", "admin", "editor"].includes(neonUser.role) &&
				<>
					<div>
						<Link to="/brand" style={{ textDecoration: "none" }}>
							<div className="d-flex gap-2">
								{path.includes("brand") ?
									<div style={{ width: 35, height: 35 }} className="bg-white  rounded opacity-75 text-center">
										{/* <img src={"/src/account-on.png"} className="w-100 opacity-100" /> */}
										<i className="bi bi-shop-window" style={{ fontSize: 23, color: " #CB3974" }}></i>
									</div>
									:
									<div className="rounded off-icon text-center">
										{/* <img src={"/src/account.png"} className="w-100 " /> */}
										<i className="bi bi-shop-window text-light" style={{ fontSize: 23 }}></i>
									</div>
								}

								<p className="text-white fs-6 m-0  align-self-center">Account/Brands</p>

							</div>
						</Link>
						{(
							path.includes("brand/auth") ||
							path.includes("brand/products") ||
							path.includes("brand/goals")
						) &&
							<div className="ps-3 pt-2 d-flex flex-column gap-2" 	>
								<Link to={"/brand/auth/" + brand.brand_entity_id} style={{ textDecoration: "none" }}>
									<div className={"d-flex gap-2 ps-1 " + (path.includes("brand/auth") ? "opacity-100" : "opacity-50")}>
										<i className="bi bi-key fs-6 text-white"></i>
										<p className="text-white mb-0 align-self-center">Authentication</p>
									</div>
								</Link>
								<Link to={"/brand/products/" + brand.brand_entity_id} style={{ textDecoration: "none" }}>
									<div className={"d-flex gap-2 ps-1 " + (path.includes("brand/products") ? "opacity-100" : "opacity-50")}>
										<i className="bi bi-box-seam fs-6 text-white"></i>
										<p className="text-white mb-0 align-self-center">Product Data</p>
									</div>
								</Link>
								<Link to={"/brand/goals/" + brand.brand_entity_id} style={{ textDecoration: "none" }}>
									<div className={"d-flex gap-2 ps-1 " + (path.includes("brand/goals") ? "opacity-100" : "opacity-50")}>
										<i className="bi bi-flag-fill fs-6 text-white"></i>
										<p className="	text-white mb-0 align-self-center">Goals</p>
									</div>
								</Link>

							</div>
						}


					</div>
					{neonUser.role != 'editor' &&

						<Link to="/users" style={{ textDecoration: "none" }}>
							<div className="d-flex gap-2">
								{path.includes("users") ?
									<div style={{ width: 35, height: 35 }} className="bg-white p-1 rounded opacity-75">
										<img src={"/src/profile-on.png"} className="w-100 opacity-100" />
									</div>
									:
									<div className=" p-1 rounded off-icon ">
										<img src={"/src/profile-off.png"} className="w-100 " />
									</div>
								}

								<p className="text-white fs-6 m-0  align-self-center">Users</p>

							</div>
						</Link>
					}
					{neonUser && ["owner"].includes(neonUser.role) &&
						<Link to="/account/subscription" style={{ textDecoration: "none" }}>

							<div className="d-flex gap-2">

								{path.includes("/subscription") ?
									<div style={{ width: 35, height: 35 }} className="bg-white p-1 rounded opacity-75">
										<img src={"/src/subs-on.png"} className="w-100 opacity-100" />
									</div>
									:
									<div className="p-1 rounded off-icon">
										<img src={"/src/subs.png"} className="w-100" />
									</div>
								}

								<p className="text-white fs-6 m-0 align-self-center">Subscription</p>

							</div>
						</Link>
					}
				</>

			}


			<Link to={`https://sidekick.bispoke.io?token=${btoa(storageParam)}`} target="_blank" style={{ textDecoration: "none" }}>
				<div className="d-flex gap-2">


					<div style={{ width: 35, height: 35 }} className=" text-center rounded off-icon">
						{/* <img src={"/src/home-off.png"} className="w-100" /> */}
						<i className="bi bi-clipboard-data text-light" style={{ fontSize: 23 }}></i>
					</div>

					<p className="text-white fs-6 m-0 align-self-center">Sidekick</p>
				</div>
			</Link>

		</>
	)
}

export default SidebarDashboardBrand